import { isObject } from '../is-object';
export function isProCodeComponentType(desc) {
  if (!isObject(desc)) {
    return false;
  }
  return 'package' in desc;
}